import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { ModalComponent } from '../modal/modal';
import { ButtonComponent } from '../button/button';
import { IconComponent } from '../icon/icon';

export type ConfirmTone = 'danger' | 'primary';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'ui-confirm-dialog',
  imports: [ModalComponent, ButtonComponent, IconComponent],
  styleUrl: './confirm-dialog.scss',
  templateUrl: './confirm-dialog.html',
})
export class ConfirmDialogComponent {
  /** Contrôle l'ouverture. */
  readonly open = input(false);

  /** Titre de la boîte de dialogue. */
  readonly title = input('Confirmer');

  /** Message affiché. */
  readonly message = input('Voulez-vous continuer ?');

  /** Libellé du bouton de confirmation. */
  readonly confirmLabel = input('Confirmer');

  /** Libellé du bouton d'annulation. */
  readonly cancelLabel = input('Annuler');

  /** Teinte du bouton de confirmation. */
  readonly tone = input<ConfirmTone>('primary');

  /** État de chargement du bouton de confirmation. */
  readonly loading = input(false);

  /** Émis à la confirmation. */
  readonly confirm = output<void>();

  /** Émis à l'annulation / fermeture. */
  readonly cancel = output<void>();

  protected onCancel(): void {
    this.cancel.emit();
  }
}
